import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  openChat() {
    $crisp.push(["do", "chat:show"])
    $crisp.push(["do", "chat:open"])
  }
}
